import React from 'react';
import { classNames, ErrorPage as EP, ErrorPageProps as EPProps } from '@groma-dev/blueprint';
import { observer } from 'mobx-react-lite';
import styles from './ErrorPage.module.scss';

export interface ErrorPageProps extends EPProps {}

const ErrorPage = observer((props: ErrorPageProps) => {
  return (
    <main className={classNames(styles.mainContainer)}>
      <EP {...props} />
    </main>
  );
});

export default ErrorPage;
